const salonId = "634ffea90bd90d1ebf7b8d03";

export const getWorkerData = async () => {
  const res = await fetch(
    `https://varaa.timma.fi/api/users/customer/${salonId}/multibooking/public`
  );
  if (res.ok) {
    return res.json() as Promise<WorkerResponse>;
  }
};

export type WorkerResponse = Worker[];

export interface Worker {
  id: string;
  title: string;
  nickName: string;
  publicSettings: PublicSettings;
  imageUrl: string;
  isTrainee: boolean;
  timeMagnet: any;
  services: ServiceInWorkerResponse[];
  additionalServices: any[];
}

export interface PublicSettings {
  timeMagnet: boolean;
  instagramPage: string;
  closeWebReservation: number;
}

export interface ServiceInWorkerResponse {
  serviceId: number;
  duration: number;
  userId: string;
  clientDuration: number;
  price: number;
}

export interface FreeTimesRequestPayload {
  noDiscounts: boolean;
  services: ServiceInPayload[];
  weekStart: string;
  strategy: string | "fair";
  /** array of user IDs */
  users: { id: string }[];
  onlySameUser: boolean;
  maxTimeInterval: number;
}

export interface ServiceInPayload {
  duration: number;
  hideFromWebReservation: boolean;
  serviceId: number;
  additionalServices: any[];
  name: string;
}

export const getFreeTimes = async (body: FreeTimesRequestPayload) => {
  const res = await fetch(
    `https://varaa.timma.fi/api/serviceslots/freetimes/multibooking/${salonId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify(body),
    }
  );
  if (res.ok) {
    return res.json() as Promise<FreeTimesResponse>;
  }
};

export type FreeTimesResponse = AvailableTime[][];

export interface AvailableTime {
  clientStart: string;
  clientEnd: string;
  additionalServices: any[];
  user: User;
  userService: UserService;
  room: any;
}

interface User {
  nickName: string;
  imageUrl: string;
  id: string;
}

interface UserService {
  serviceId: number;
  duration: number;
  price: number;
  lastMinute?: boolean;
  lastMinutePrice: number;
  offPeak: boolean;
  offPeakPrice?: number;
  clientDuration: number;
  resources: any[];
  serviceName: string;
}

export interface BookTimeRequestPayload {
  anyUser: boolean;
  customerId: string;
  combo: Combo[];
  clientName: string;
  clientPhone: string;
  clientAddress: string;
  clientCity: string;
  clientPostalCode: string;
  clientEmail: string;
  clientMessage: string;
  socialSecurityNumber: string;
  acceptEmailMarketing: boolean;
  acceptSmsMarketing: boolean;
  pageOrigin: string;
  timestamp1: any;
  verificationCode: any;
}

interface Combo {
  userId: string;
  anyUser: boolean;
  start: string;
  serviceId: number;
  serviceName: string;
  additionalServices: any[];
  room: any;
}

export const bookTime = async (body: BookTimeRequestPayload) => {
  const res = await fetch(
    `https://varaa.timma.fi/api/serviceslots/multibookingreservation?lang=en`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );
  if (res.ok) {
    return res.json() as Promise<BookTimeResponse>;
  }
};

export type BookTimeResponse = BookTimeRow[];

interface BookTimeRow {
  serviceSlot: ServiceSlot;
  commissionAmount: any;
}

interface ServiceSlot {
  userId: string;
  comboId: string;
  clientId: string;
  customerId: string;
  clientName: string;
  clientPhone: string;
  clientEmail: string;
  start: string;
  end: string;
  status: string;
  title: string;
  reservation: Reservation;
  reminded: boolean;
  smsReminded: boolean;
  rooms: any;
  createdAt: string;
  updatedAt: string;
  resourceId: string;
  id: string;
  deletedOn: any;
  seriesId: any;
}

interface Reservation {
  anyUser: boolean;
  serviceId: number;
  cancelCode: string;
  onlinePrice: any;
  serviceName: string;
  salesChannel: string;
  servicePrice: number;
  clientMessage: string;
  additionalServices: any[];
  isMarketplaceReservation: boolean;
}
